import React from 'react';
import PropTypes from 'prop-types';
import { pageContext } from 'ctm-util-functions';
import styled from 'styled-components';
import { BrandLogo } from '../brand_logo/brand_logo';

const Card = styled.div`
    display: flex;
    flex-direction: ${(props) => (props.isMobile === 'sm' || props.isMobile === 'xs' ? 'column' : 'row')};
    align-items: center;
    width: ${(props) => props.breakpoint};
    padding: 15px 50px;
    border: 1px solid #dddddd;
    height: ${(props) => (props.isMobile === 'sm' || props.isMobile === 'xs' ? 'unset' : '110px')};
    margin-bottom: 12px;
    justify-content: space-between;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: ${(props) => (props.isMobile === 'sm' || props.isMobile === 'xs' ? 'column' : 'row')};
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    h1 {
        color: #ada8a6;
        font-size: 2rem;
        line-height: 3rem;
        font-weight: 600;
    }
    p {
        color: #787573;
        font-size: 1.4rem;
        line-height: 2.2rem;
    }
`;

/**
 * Returns the width value based on the given breakpoint.
 *
 * @param {string} breakpoint - The breakpoint value ('sm', 'md', 'lg', 'xl', or 'xxl').
 * @return {string} The corresponding width value ('100%', '75%', '83.3%', or '100%').
 */
const setWidthByBreakpoint = (breakpoint) => {
    const breakpointWidthMap = {
        sm: '100%',
        md: '75%',
        lg: '75%',
        xl: '83.3%',
        xxl: '100%'
    };

    return breakpointWidthMap[breakpoint] || '100%';
};

/**
 * Renders a card component to display a message indicating that a quote has expired.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.quote - The quote object containing providerMeta.code.
 * @return {JSX.Element} The rendered QuoteExpiredCard component.
 */
const QuoteExpiredCard = (props) => {
    const { quote } = props;
    const vertical = pageContext.getVertical();
    const brandLogoElementProps = { srcPath: `/evt/assets/images/logos/${vertical}`, brandCode: quote.getIn(['providerMeta', 'code']) };
    const getBreakpoint = pageContext.getProps().pageState.breakpoint;

    return (
        <Card id={`${brandLogoElementProps.brandCode}_quote_expired`} breakpoint={setWidthByBreakpoint(getBreakpoint)} isMobile={getBreakpoint}>
            <BrandLogo elementProps={brandLogoElementProps} />
            <TextContainer breakpoint={getBreakpoint} isMobile={getBreakpoint}>
                <h1>Quote Expired</h1>
                <p>For a new quote please select 'Update Quotes' above.</p>
            </TextContainer>
        </Card>
    );
};

QuoteExpiredCard.propTypes = {
    quote: PropTypes.object
};

export { QuoteExpiredCard };
